import { prepareFormSubmittedEvent } from "./prepare-form-submitted-event"
import { prepareFormSubmittedIdentifyTraits } from "./prepare-form-submitted-identify-traits"
import { AnalyticsWindow } from "../window"

declare let window: AnalyticsWindow

type FormViewedEventProperties = {
  formId: string
  formProvider: string
  url: string
  path: string
}

export function handleHubspotFormReady(event: MessageEvent<any>) {
  if (!window.analytics) return

  if (event.data.id) {
    let eventProperties: FormViewedEventProperties = {
      formId: event.data.id,
      formProvider: "hubspot",
      url: window.location.href,
      path: window.location.pathname,
    }

    window.analytics.track("Form viewed", eventProperties)
  }
}

export function handleHubspotFormSubmit(event: MessageEvent<any>) {
  if (event.data.data) {
    prepareFormSubmittedEvent(event.data.id, event.data.data)
    prepareFormSubmittedIdentifyTraits(event.data.data)
  }
}
